// types
import { financiers, financiersExt, financiersWbg } from '../@types/unions';

// i18n
import { TFunction } from 'i18next';

export interface GetOptionsActStatusesProps {
	hasDescription?: boolean;
	t: TFunction;
}

export const getOptionsActStatuses = ({ hasDescription, t }: GetOptionsActStatusesProps) => {
	return [
		{
			label: t('started'),
			secondary: hasDescription ? t('act.started.description') : undefined,
			value: 'STARTED',
		},
		{
			label: t('pending'),
			secondary: hasDescription ? t('act.pending.description') : undefined,
			value: 'PENDING',
		},
		{
			label: t('ready'),
			secondary: hasDescription ? t('act.ready.description') : undefined,
			value: 'READY',
		},
		{
			label: t('completed'),
			secondary: hasDescription ? t('act.completed.description') : undefined,
			value: 'COMPLETED',
		},
	];
};

export const getOptionsEntityTypes = (t: TFunction) => {
	return [
		{
			label: t('auditor'),
			value: 'AUDITOR',
		},
		{
			label: t('borrower'),
			value: 'BORROWER',
		},
		{
			label: t('donor'),
			value: 'DONOR',
		},
		{
			label: t('intermediary'),
			value: 'INTERMEDIARY',
		},
		{
			label: t('piu'),
			value: 'PIU',
		},
		{
			label: t('subPiu'),
			value: 'SUB_PIU',
		},
		{
			label: t('taxAuthority'),
			value: 'TAX_AUTHORITY',
		},
	];
};

export const getOptionsFinanciersExt = () => {
	return financiersExt.map((financier) => {
		return {
			label: financier,
			value: financier,
		};
	});
};

export const getOptionsFinanciersWbg = () => {
	return financiersWbg.map((financier) => {
		return {
			label: financier,
			value: financier,
		};
	});
};

export const getOptionsFinanciers = () => {
	return financiers.map((financier) => {
		return {
			label: financier,
			value: financier,
		};
	});
};
